module.exports = __webpack_public_path__ + "img/about04.9a00d848.png";